/**
 * 拓扑插件-节点/边等图形状态常量
 */
export default {
  // 默认状态
  defaultState: 'defaultState',
  // 不可用/不可选
  disable: 'disable',
  // 唤起，鼠标经过/悬停
  active: 'active',
  // 选择，鼠标单击/双击/框选/拖拽/吸附
  selected: 'selected',
  // 强化，点亮对比既定节点时，做突出展示
  highlight: 'highlight',
  // 弱化，点亮对比别的节点时，做弱化展示
  inactive: 'inactive',

  // 健康的
  healthy: 'healthy',
  // 告警时
  warning: 'warning',
  // 错误时
  error: 'error',


  // 单击事件
  click: 'click',
  // 鼠标移入或悬停事件
  hover: 'hover',
  // 移动事件
  move: 'move'
};
